import Vue from "vue";
import store from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const faIcons = [
  "AddressCard",
  "BookOpen",
  "BookDead",
  "BroadcastTower",
  "Bars",
  "Chair",
  "Circle",
  "CheckSquare",
  "CloudMoon",
  "Cog",
  "Copy",
  "Clipboard",
  "Comment",
  "Dice",
  "Dragon",
  "ExchangeAlt",
  "ExclamationTriangle",
  "FileCode",
  "FileUpload",
  "HandPaper",
  "HandPointRight",
  "Heartbeat",
  "Image",
  "Link",
  "Keyboard",
  "MinusCircle",
  "Microphone",
  "MicrophoneSlash",
  "PeopleArrows",
  "PaperPlane",
  "Play",
  "FlagCheckered",
  "PlusCircle",
  "Question",
  "Random",
  "RedoAlt",
  "SearchMinus",
  "SearchPlus",
  "Skull",
  "SlidersH",
  "Square",
  "TheaterMasks",
  "Times",
  "TimesCircle",
  "TrashAlt",
  "Undo",
  "User",
  "UserEdit",
  "UserFriends",
  "UserSecret",
  "Users",
  "VenusMars",
  "VolumeUp",
  "VolumeMute",
  "VoteYea",
  "WindowMaximize",
  "WindowMinimize"
];
const fabIcons = ["Github", "Discord"];
library.add(
  ...faIcons.map(i => fas["fa" + i]),
  ...fabIcons.map(i => fab["fa" + i])
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

/**
 * 两个入口，同一个构建产物。
 *
 * - 后台入口是私有路径（下面是唯一判定来源）：只有它才加载 Admin 代码，
 *   普通页面永远不会下载后台 chunk，也不会出现任何入口痕迹。
 * - 游戏页（包含曾经的 /admin 这类未定义路径）走原来的 App.vue。
 *
 * 注意：App.vue 必须**动态** import。App.vue 的 <style> 不是 scoped，
 * 里面有 `html, body { height:100%; overflow:hidden }` 这类游戏页全局规则；
 * 静态 import 会让这些规则在后台页也生效，把后台整页锁住无法滚动。
 */
const ADMIN_PATH = "/seasea3216";
const currentPath = window.location.pathname.toLocaleLowerCase();
const isAdminRoute =
  currentPath === ADMIN_PATH || currentPath.startsWith(`${ADMIN_PATH}/`);

if (isAdminRoute) {
  import("./admin/bootstrap").then(module => module.mountAdminConsole());
} else {
  import("./App").then(({ default: App }) => {
    new Vue({
      render: h => h(App),
      store
    }).$mount("#app");
    // 站点配置与 Admin 内容库：非阻塞加载，失败时保持内置默认值。
    import("./adminLibrary").then(({ initSiteContent }) => initSiteContent());
  });
}
